/* LIVING FOOD - THEME JS v25 */
document.addEventListener('DOMContentLoaded', function() {

  /* ── ANNOUNCEMENT ROTATOR ── */
  var annSlides = document.querySelectorAll('.ann-slide');
  if (annSlides.length > 1) {
    var annIdx = 0;
    setInterval(function() {
      annSlides[annIdx].classList.remove('active');
      annIdx = (annIdx + 1) % annSlides.length;
      annSlides[annIdx].classList.add('active');
    }, 3500);
  }

  /* ── MARQUEE COLOR CYCLING (every 5s) ── */
  var marqueeColors = ['#D4841A','#C85060','#8A9E7A','#9088B8','#C8A830','#8858A8','#4A84B8'];
  var marqueeIdx = 0;
  var marqueeEl = document.getElementById('marquee-bar');
  if (marqueeEl) {
    setInterval(function() {
      marqueeIdx = (marqueeIdx + 1) % marqueeColors.length;
      marqueeEl.style.background = marqueeColors[marqueeIdx];
      marqueeEl.style.transition = 'background 1s ease';
    }, 5000);
  }

  /* ── NAV SCROLL ── */
  var navW = document.getElementById('nav-wrapper');
  if (navW) {
    window.addEventListener('scroll', function() {
      navW.classList.toggle('scrolled', window.pageYOffset > 40);
    }, { passive: true });
  }

  /* ── MOBILE MENU ── */
  var ham = document.getElementById('nav-hamburger');
  var mob = document.getElementById('mobile-menu');
  var mobOv = document.getElementById('mobile-overlay');
  var mobClose = document.getElementById('mobile-close');
  function openMob() { mob && mob.classList.add('open'); mobOv && mobOv.classList.add('open'); ham && ham.classList.add('active'); document.body.style.overflow = 'hidden'; }
  function closeMob() { mob && mob.classList.remove('open'); mobOv && mobOv.classList.remove('open'); ham && ham.classList.remove('active'); document.body.style.overflow = ''; }
  if (ham) ham.addEventListener('click', function() { mob && mob.classList.contains('open') ? closeMob() : openMob(); });
  if (mobClose) mobClose.addEventListener('click', closeMob);
  if (mobOv) mobOv.addEventListener('click', closeMob);

  /* ── MARQUEE COLOR CYCLING ── */
  var mqBar = document.getElementById('marquee-bar');
  if (mqBar) {
    var mqColors = ['#D4841A','#C85060','#8A9E7A','#9088B8','#C8A830','#8858A8','#4A84B8'];
    var mqIdx = 0;
    setInterval(function() {
      mqBar.style.background = mqColors[mqIdx % mqColors.length];
      mqIdx++;
    }, 5000);
  }

  /* ── MARQUEE COLOR CYCLING ── */
  var mqBar = document.getElementById('marquee-bar');
  if (mqBar) {
    var mqColors = ['#D4841A','#C85060','#8A9E7A','#9088B8','#C8A830','#8858A8','#4A84B8'];
    var mqIdx = 0;
    setInterval(function() {
      mqBar.style.background = mqColors[mqIdx % mqColors.length];
      mqBar.style.transition = 'background .8s';
      mqIdx++;
    }, 5000);
  }

  /* ── REVIEWS CAROUSEL ── */
  var revTrack = document.getElementById('rev-track');
  var revDots = document.querySelectorAll('.rev-dot');
  var revIdx = 0;
  var revTotal = revDots.length || 0;
  var revAuto;

  function revSet(i) {
    revIdx = i;
    if (revTrack) revTrack.style.transform = 'translateX(-' + (i * (100 / revTotal)) + '%)';
    revDots.forEach(function(d, j) { d.classList.toggle('active', j === i); });
  }

  window.revGo = function(d) {
    revIdx = (revIdx + d + revTotal) % revTotal;
    revSet(revIdx);
    clearInterval(revAuto);
    revAuto = setInterval(function() { revGo(1); }, 5000);
  };

  window.revSet = function(i) {
    revSet(i);
    clearInterval(revAuto);
    revAuto = setInterval(function() { revGo(1); }, 5000);
  };

  revDots.forEach(function(d, i) {
    d.addEventListener('click', function() { window.revSet(i); });
  });

  if (revTotal > 0) {
    revAuto = setInterval(function() { revGo(1); }, 5000);
  }

  /* ── VARIANT DROPDOWN ── */
  window.toggleVariants = function(btn) {
    var w = btn.closest('.add-variants');
    if (!w) return;
    var dd = w.querySelector('.vdrop');
    if (!dd) return;
    var was = dd.classList.contains('open');
    closeAllVariants();
    if (!was) dd.classList.add('open');
  };
  window.closeAllVariants = function() {
    document.querySelectorAll('.vdrop.open').forEach(function(d) { d.classList.remove('open'); });
  };
  document.addEventListener('click', function(e) {
    if (!e.target.closest('.add-variants')) closeAllVariants();
  });

  /* ── CART DRAWER ── */
  function openCart() {
    var d = document.getElementById('cart-drawer'), o = document.getElementById('cart-overlay');
    if (d) d.classList.add('open'); if (o) o.classList.add('open');
    document.body.style.overflow = 'hidden';
  }
  function closeCart() {
    var d = document.getElementById('cart-drawer'), o = document.getElementById('cart-overlay');
    if (d) d.classList.remove('open'); if (o) o.classList.remove('open');
    document.body.style.overflow = '';
  }
  var cartBtn = document.getElementById('nav-cart');
  if (cartBtn) cartBtn.addEventListener('click', function(e) { e.preventDefault(); refreshCart().then(openCart); });
  var ccBtn = document.getElementById('cart-close');
  if (ccBtn) ccBtn.addEventListener('click', closeCart);
  var cOv = document.getElementById('cart-overlay');
  if (cOv) cOv.addEventListener('click', closeCart);

  function updateCartUI(cart) {
    var c = document.getElementById('cart-count');
    if (c) c.textContent = cart.item_count;
    renderCart(cart);
  }

  function refreshCart() {
    return fetch('/cart.js').then(function(r) { return r.json(); }).then(function(cart) { updateCartUI(cart); return cart; }).catch(function(e) { console.error('LF: refreshCart', e); });
  }

  function renderCart(cart) {
    var body = document.getElementById('cart-drawer-body');
    if (!body) return;
    if (!cart || !cart.items || cart.items.length === 0) {
      body.innerHTML = '<div class="cd-empty">🍵<br>O teu cesto está vazio.<br><a href="/pages/loja" style="color:var(--sage);font-size:.75rem;font-weight:500;text-transform:uppercase;letter-spacing:.02em;margin-top:.5rem;display:inline-block;">Ver produtos →</a></div>';
      return;
    }
    var h = '';
    for (var i = 0; i < cart.items.length; i++) {
      var it = cart.items[i];
      var img = it.image ? '<img src="' + it.image + '" alt="">' : '';
      var vt = it.variant_title ? '<div class="cd-item-var">' + it.variant_title + '</div>' : '';
      h += '<div class="cd-item"><div class="cd-item-img">' + img + '</div><div><div class="cd-item-title">' + it.product_title + '</div>' + vt + '<div class="cd-item-btm"><div class="cd-qty"><button onclick="lfQty(\'' + it.key + '\',' + (it.quantity > 1 ? it.quantity - 1 : 0) + ')">−</button><span>' + it.quantity + '</span><button onclick="lfQty(\'' + it.key + '\',' + (it.quantity + 1) + ')">+</button></div><div class="cd-item-price">€' + (it.line_price / 100).toFixed(2) + '</div></div><button class="cd-remove" onclick="lfQty(\'' + it.key + '\',0)">Remover</button></div></div>';
    }
    h += '<div class="cd-total"><span class="cd-total-label">Total</span><span class="cd-total-price">€' + (cart.total_price / 100).toFixed(2) + '</span></div>';
    h += '<a href="/checkout" class="btn-primary" style="width:100%;text-align:center;display:flex;margin-top:.75rem;">Finalizar encomenda →</a>';
    h += '<a href="/pages/loja" style="display:block;text-align:center;margin-top:.65rem;font-size:.72rem;font-weight:500;text-transform:uppercase;letter-spacing:.02em;color:var(--mid);text-decoration:none;">← Continuar a comprar</a>';
    body.innerHTML = h;
  }

  /* ── ADD TO CART ── */
  window.addToCart = function(vid, qty) {
    var id = String(vid || '').trim();
    if (!id || id === 'undefined' || id === 'null') {
      var b = document.getElementById('cart-drawer-body');
      if (b) b.innerHTML = '<div class="cd-empty">⚠️<br>Seleciona um tamanho primeiro.</div>';
      openCart(); return;
    }
    closeAllVariants();
    openCart();
    var b2 = document.getElementById('cart-drawer-body');
    if (b2) b2.innerHTML = '<div class="cd-empty" style="padding:2rem 0;">⏳ A adicionar...</div>';
    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/x-www-form-urlencoded', 'Accept': 'application/json' },
      body: 'id=' + encodeURIComponent(id) + '&quantity=' + (qty || 1)
    }).then(function(r) {
      if (!r.ok) return r.json().then(function(e) { throw new Error(e.description || 'Erro'); });
      return r.json();
    }).then(function() { return refreshCart(); }).catch(function(err) {
      var b3 = document.getElementById('cart-drawer-body');
      if (b3) b3.innerHTML = '<div class="cd-empty">⚠️<br>' + err.message + '<br><a href="/pages/loja" style="color:var(--sage);font-size:.72rem;margin-top:.5rem;display:inline-block;">Ver produtos →</a></div>';
    });
  };

  window.lfQty = function(key, qty) {
    fetch('/cart/change.js', { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ id: key, quantity: qty }) })
    .then(function(r) { return r.json(); }).then(function(cart) { updateCartUI(cart); });
  };

  refreshCart();

  /* ── REVEAL ON SCROLL ── */
  var revEls = document.querySelectorAll('.reveal');
  if ('IntersectionObserver' in window) {
    var obs = new IntersectionObserver(function(entries) {
      entries.forEach(function(e) { if (e.isIntersecting) { e.target.classList.add('visible'); obs.unobserve(e.target); } });
    }, { threshold: 0.08, rootMargin: '0px 0px -40px 0px' });
    revEls.forEach(function(el) { obs.observe(el); });
  } else { revEls.forEach(function(el) { el.classList.add('visible'); }); }

  /* ── SHOP FILTERS ── */
  window.filterProducts = function(cat, btn) {
    document.querySelectorAll('.shop-filter').forEach(function(b) { b.classList.remove('active'); });
    btn.classList.add('active');
    document.querySelectorAll('[data-category]').forEach(function(card) {
      card.style.display = (cat === 'all' || card.dataset.category === cat) ? '' : 'none';
    });
  };
});
